import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './css/invoice.css';
import commaNumber from 'comma-number';

let format = commaNumber.bindWith(',', '.');

const InvoiceBody = ({ saleData, showDetailedView }) => {
    const classes = useStyles();
    const [sale, setSale] = useState([]);
    const [saleDetails, setSaleDetails] = useState([]);

    useEffect(() => {
        setSale(saleData);
        if (saleData?.details !== undefined) {
            setSaleDetails(saleData.details);
        } else if (saleData?.line_items !== undefined) {
            setSaleDetails(saleData.line_items);
        } else if (saleData?.items !== undefined) {
            setSaleDetails(saleData.items);
        } else {
            setSaleDetails([]);
        }
    }, [saleData]);

    return (
        <>
            <table className={'invoice-table'}> 
                <thead>
                    <tr>
                        <th style={{textAlign:'left'}}>SL</th>
                        <th style={{textAlign:'left'}}>Category</th>
                        <th style={{textAlign:'left'}}>Product</th>
                        <th style={{textAlign:'left'}}>Brand</th>
                        <th style={{textAlign:'left'}}>Country</th>
                        <th>Unit</th>
                        <th>Unit price in BDT</th>  
                        {showDetailedView && <th>Qty</th>}
                        {showDetailedView && <th>Total</th>}
                    </tr>
                </thead>
                <tbody>
                    {saleDetails.map((detail, ind) => (
                        <tr key={ind}>
                            <td style={{textAlign:'left'}}>{ind + 1}</td>
                            <td style={{textAlign:'left'}}>{detail.prod_cat_name}</td>
                            <td style={{textAlign:'left'}}>{detail.prod_name}</td>
                            <td style={{textAlign:'left'}}>{detail.prod_brand_name}</td>
                            <td style={{textAlign:'left'}}>{detail.prod_color_name || detail.country_origin || "-"}</td>
                            <td style={{textAlign:'center'}}>{detail.prod_unit_name}</td>
                            <td style={{textAlign:'center'}}>{detail.sale_rate}</td>
                            {showDetailedView && <td>{detail.sale_qty}</td>}
                            {showDetailedView && (
                                <td style={{textAlign:'right'}}>
                                    {format(parseFloat(detail.sale_prod_total).toFixed(2))}
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

const useStyles = makeStyles((theme) => ({
    // Add any custom styles here if needed
}));

export default InvoiceBody;
